import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=5ddb3e65&scoped=true&"
import script from "./Index.vue.js?vue&type=script&lang=js&"
export * from "./Index.vue.js?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=5ddb3e65&scoped=true&lang=scss&"
import style1 from "./Index.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddb3e65",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCheckbox,VForm,VImg,VTextField})
